<template>
  <div>
    <!-- <template v-if="showProfileDefault">
      <Exception placeholder-class-name="no-avalible-data-img" tip-text="The teacher's profile is coming soon" />
    </template> -->
    <div class="profile">
      <div :class="`introduce ${videoOptions.sources[0].src&&profileInfo.achievementList.length?'combine':''}`">
        <div v-if="videoOptions.sources[0].src" class="video-wrapper">
          <video-player ref="videoPlayer" :options="videoOptions" class="vjs-theme-fantasy" />
        </div>
        <div v-if="profileInfo.achievementList.length" class="detail achievements">
          <div class="title">
            {{ $t('teacher.achievement') }}
          </div>
          <div class="txt">
            <div class="achievementList">
              <div v-for="(item, index) in profileInfo.achievementList" :key="index" class="teacher-description">
                <span />  {{ item }}
              </div>
            </div>
            <img class="writing" v-lazy-load data-src="~assets/images/teacher/writing.png">
          </div>
        </div>
      </div>
      <div v-if="profileInfo.experience " class="detail experience">
        <div class="experience">
          <UkContent :content="profileInfo.experience " show-bg />
          <div class="simple-detail">
            <ThinTeacherInfo :teacher="profileInfo" :identity-tag="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Exception from 'components/common/Exception';
import VideoPlayer from 'components/common/VideoPlayer/index';
import UkContent from 'components/courses/UkContent'
import ThinTeacherInfo from 'components/teacher/ThinTeacherInfo'

export default {
  components: {
    VideoPlayer, UkContent, ThinTeacherInfo,
  },
  props: {
    profileInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      videoOptions: {
        autoplay: false,
        controls: true,
        playsinline: true,
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
      },
    }
  },
  computed: {
    showProfileDefault() {
      return !this.profileInfo.videoUrl && !this.profileInfo.achievementList.length && !this.profileInfo.experience
    },
  },
  created() {
    if (this.profileInfo.videoUrl) {
      this.videoOptions.sources[0].src = this.profileInfo.videoUrl;
    }
  },
}
</script>
<style lang="scss" scoped>
.profile {
  /deep/
  .vjs-theme-fantasy {
    height: 100%;

    .video-js {
      margin: 0 auto;
      width: 612px;
      height: 100%;
      border-radius: 10px;
      overflow: hidden;

      .vjs-big-play-button {
        width: 82px;
        height: 82px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-image: url("~assets/images/teacher/play.png");

        &::after {
          display: none;
        }

        .vjs-icon-placeholder {
          &::before {
            display: none;
          }
        }
      }
    }
  }

  .detail {
    &.experience {
      background: #fff;
      border-radius: 10px;
      margin-top: 30px;

      /deep/.uk-introduce-box {
        margin-bottom: 0;
      }

      .simple-detail {
        border-top: rgba(222, 226, 231, 1) 1px dashed;
        margin: 0 40px;
        padding: 20px 0;
      }
    }

    .txt {
      font-size: 20px;
      font-weight: 500;
      color: rgba(69, 85, 113, 1);
      line-height: 28px;
      word-break: break-word;
    }

    &.achievements {
      display: flex;

      .title {
        width: 260px;
        background: #fff;
        padding: 40px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 26px;
        color: var(--txt-color-lv1);
        font-weight: 600;
        line-height: 31px;
        border-radius: 12px 0 0 12px;
        background-size: 180px 69px;
        background-image: url("~assets/images/teacher/achievements_title.png");
        background-repeat: no-repeat;
        background-position: center;
      }

      .txt {
        width: 978px;
        padding: 42px;
        margin-left: 2px;
        background: #fff;
        border-radius: 0 12px 12px 0;
        position: relative;

        .writing {
          width: 131px;
          position: absolute;
          right: 0;
          bottom: -10px;
        }

        .achievementList {
          padding-left: 0;
          min-height: 136px;

          .teacher-description {
            font-size: 20px;
            color: var(--txt-color-lv3);
            line-height: 24px;
            font-weight: 600;
            display: block;
            margin-bottom: 20px;

            span {
              display: inline-block;
              width: 10px;
              height: 10px;
              background: var(--txt-color-link);
              border-radius: 50%;
            }
          }
        }
      }
    }
  }

  .introduce {
    display: flex;

    &.combine {
      /deep/.video-js {
        width: 720px;
      }

      .detail.achievements {
        margin-left: 10px;
        display: block;
        width: 510px;
        background: #fff;
        border-radius: 10px;
        position: relative;

        .title {
          margin: 0 auto;
        }

        .txt {
          width: auto;
          padding-top: 20px;
          position: initial;
          border-radius: 12px;

          .achievementList {
            .teacher-description {
              writing-mode: initial;
              display: block;
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
